import * as angular from "angular";
import { ActivityFilter } from "../../models/activity-filter.model";
import { DialogUtils } from "../../helper/dialog.helper";
import * as _ from "lodash";

export let ActivityFilterDialogComponent = {
    selector: "vcActivityFilterDialog",
    templateUrl:
        "/angular/components/activity/activity-filter-dialog.component.html",
    bindings: {
        mode: "=?",
        activeFilter: "=?",
    },
    controller: class ActivityFilterDialogController {
        // * bindings for typescript compiler *
        public mode?: any;
        public activeFilter?: ActivityFilter;
        // ************************************

        private dialog: DialogUtils;
        public filter: ActivityFilter;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            if (angular.equals(this.activeFilter, {})) {
                this.filter = new ActivityFilter(null, this.mode);
            } else {
                this.filter = new ActivityFilter(this.activeFilter);
            }
        }

        clear(): void {
            this.dialog.hide(new ActivityFilter(null, this.mode));
        }

        ok(): void {
            angular.forEach(this.activeFilter, (filterItem) => {
                if (filterItem && filterItem.values) {
                    filterItem.values = [];
                }
            });
            _.merge(this.activeFilter, this.filter);
            this.dialog.hide(this.filter);
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("activity")
    .component(
        ActivityFilterDialogComponent.selector,
        ActivityFilterDialogComponent
    );
